import { render } from "./ModalFormArea.vue?vue&type=template&id=777540cf&scoped=true"
import script from "./ModalFormArea.vue?vue&type=script&lang=js"
export * from "./ModalFormArea.vue?vue&type=script&lang=js"

import "./ModalFormArea.vue?vue&type=style&index=0&id=777540cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777540cf"]])

export default __exports__